import axios from 'axios';
import { API_ENDPOINT } from '../constants/api-endpoints';

const useAxiosInterceptor = () => {

    const axiosInstance = axios.create({
        baseURL: API_ENDPOINT.BASE_URL,
    });

    return axiosInstance;
};

export default useAxiosInterceptor;
